import { render, staticRenderFns } from "./AddNewUser.vue?vue&type=template&id=74a5f5aa&"
import script from "./AddNewUser.vue?vue&type=script&lang=ts&"
export * from "./AddNewUser.vue?vue&type=script&lang=ts&"
import style0 from "./AddNewUser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports